import { useQuery } from '@tanstack/react-query';
import { receivedDemandsService } from '../../../../services/receivedDemands';

/**
 * Hook para buscar uma demanda específica com cache e refetch automático
 */
export const useDemandQuery = (demandaId: number | undefined) => {
  return useQuery({
    queryKey: ['demanda', demandaId],
    queryFn: async () => {
      if (!demandaId) throw new Error('ID da demanda não fornecido');
      return receivedDemandsService.getDemanda(demandaId);
    },
    enabled: !!demandaId,
    staleTime: 1000 * 30, // 30 segundos - dados são considerados frescos
    gcTime: 1000 * 60 * 5, // 5 minutos - tempo no cache após inativo
    refetchOnWindowFocus: true, // Refetch quando usuário volta à aba
    retry: 1, // Tentar novamente 1 vez em caso de erro
  });
};

/**
 * Query keys para invalidação de cache
 */
export const demandQueryKeys = {
  all: ['demanda'] as const,
  detail: (id: number) => ['demanda', id] as const,
  lists: () => ['demandas'] as const,
  list: (type: string) => ['demandas', type] as const,
};
